// import 'core-js/stable' //needed for ie11 support (payload: 373KB!!!)llScript
// import 'regenerator-runtime/runtime'
import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
// import VueAnime from 'vue-animejs'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'
//import Drawer from './components/Drawer.vue'
//import Vue2Crumbs from 'vue-2-crumbs'
import VueScrollTo from 'vue-scrollto'
// import VueCountdown from '@chenfengyuan/vue-countdown'
import './registerServiceWorker'
import interceptors from './api/interceptors'
import {setDomain} from './api/backend'
import {setShopCurrency} from './api/checkout-api'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate'
import {
  required,
  email,
  numeric,
  oneOf,
  min,
  confirmed,
} from 'vee-validate/dist/rules'
import './filters/currency-filter'
import './filters/iso-country-filter'
import './filters/theme-filter'
import './filters/gender-filter'
import './filters/amount-filter'
import './filters/capitalize-filter'
import './filters/remove-special-chars'
import './filters/promotion-filter'
import './filters/price-prefix-abbrevation'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueContentPlaceholders from 'vue-content-placeholders'
import VueMeta from 'vue-meta'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'

import VueFilterDateFormat from 'vue-filter-date-format'
import vueDebounce from 'vue-debounce'
import VueObserveVisibility from 'vue-observe-visibility'
import VueLazyload from 'vue-lazyload'
import VueGtm from 'vue-gtm'
import i18n from './i18n'

import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'

import Awin from '@/common/awin-plugin/'
import Adcell from '@/common/adcell-plugin/'

import {dispatcher} from '@/common/event-dispatcher'
import {createGTMListeners} from '@/common/gtm-subscriber'
import {createGTAGListeners} from '@/common/gtag-subscriber'
import {createGAListeners} from '@/common/ga-subscriber'
import {createFBPListeners} from '@/common/fbpixel-subscriber'

import {createLogger} from '@/common/log'

const logger = createLogger('main.js', '', false)

if (process.env.VUE_APP_SENTRY_ENABLE) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: process.env.VUE_APP_SENTRY_SAMPLERATE,
    environment: `${process.env.NODE_ENV}-${process.env.VUE_APP_THEME}`,
    logErrors: process.env.VUE_APP_SENTRY_LOG_VUE_ERR ? true : false, //if true will trigger vue errors as well (for dev)
    tracingOptions: {
      trackComponents: true,
    },
  })
}

setDomain(process.env.VUE_APP_API)
setShopCurrency(process.env.VUE_APP_CURRENCY)
interceptors()

//settings available in all components

const config = require(process.env.CONFIG_LOCATION)
Vue.prototype.$whitelabel = config.whitelabelConfig
if (
  process.env.VUE_APP_ALLOW_GIFT_CARD &&
  process.env.VUE_APP_ALLOW_GIFT_CARD == 'true'
) {
  Vue.prototype.$whitelabel.giftCardSupport = true
}
Vue.config.productionTip = false

if (!Vue.prototype.$whitelabel.hasCookieConsent) {
  localStorage.acceptAllCookies = true
}

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultTooltipAnimated: true,
  defaultDayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  defaultMonthNames: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  defaultFirstDayOfWeek: 1,
})

// Vue.use(VueAnime)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_KEY,
  },
})
Vue.use(VueContentPlaceholders)

let analyticstype = Vue.prototype.$whitelabel.analyticsType

if (analyticstype == 'gtag' || analyticstype == 'both') {
  Vue.use(
    VueGtag,
    {
      config: {
        id: Vue.prototype.$whitelabel.analyticsId,
        params: {
          anonymize_ip: true,
        },
      },
      // enabled: () => {
      //   if (localStorage.acceptAllCookies === 'true') {
      //     return true
      //   }
      //   return false
      // },
      //enabled: false,
      bootstrap: false,
    },
    router,
  )

  // if (process.env.NODE_ENV === 'development') {
  //   Vue.$gtag.enabled = false
  // }
  if (localStorage.acceptAllCookies === 'true') {
    Vue.$gtag.optIn() // https://github.com/MatteoGabriele/vue-gtag/issues/199
  }
}

if (analyticstype == 'ua' || analyticstype == 'both') {
  Vue.use(VueAnalytics, {
    id: Vue.prototype.$whitelabel.analyticsId_ua,
    ecommerce: {
      enabled: true,
      enhanced: true,
    },
    disabled: () => {
      if (localStorage.acceptAllCookies === 'true') {
        return false
      }
      return true
    },
    //disabled: true,
    router,
    beforeFirstHit() {
      //see https://github.com/MatteoGabriele/vue-analytics/issues/64
      Vue.$ga.set('anonymizeIp', true)
    },
    debug: {
      //enabled: process.env.NODE_ENV === 'development',
      enabled: false,
      trace: false,
      sendHitTask: process.env.NODE_ENV === 'production',
    },
  })

  // if (process.env.NODE_ENV === 'development') {
  //   Vue.$ga.disabled = true
  // }

  if (localStorage.acceptAllCookies === 'true') {
    logger.debug('ua analytics enabled')
    Vue.$ga.enable()
  }
}

if (Vue.prototype.$whitelabel.tagManager) {
  Vue.use(VueGtm, {
    id: Vue.prototype.$whitelabel.tagManager.id, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: process.env.NODE_ENV === 'development', // Whether or not display console logs debugs (optional)
  })

  if (localStorage.acceptAllCookies === 'true') {
    Vue.gtm.enable(true)
  }
}

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
})

if (Vue.prototype.$whitelabel.fbPixelEnabled) {
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  Vue.use(VueFacebookPixel)
  if (localStorage.acceptAllCookies === 'true') {
    Vue.analytics.fbq.init(Vue.prototype.$whitelabel.fbPixelId)
    Vue.analytics.fbq.event('PageView')
  }
}

Vue.use(VueFilterDateFormat)
extend('required', {
  ...required,
  message: (_, values) => i18n.t('validation.required', values),
})
extend('email', {
  ...email,
  message: (_, values) => i18n.t('validation.email', values),
})
extend('numeric', {
  ...numeric,
  message: (_, values) => i18n.t('validation.numeric', values),
})
extend('oneOf', {
  ...oneOf,
  message: (_, values) => i18n.t('validation.oneOf', values),
})

extend('min', {
  ...min,
  message: (_, values) => i18n.t('validation.min', values),
})

extend('confirmed', {
  ...confirmed,
  message: (_, values) => i18n.t('validation.confirmed', values),
})

extend('date', {
  validate: value =>
    value.match(/^(0?[1-9]|[12][0-9]|3[01]).(0?[1-9]|1[012]).\d{4}$/), // the validation function
  message: (_, values) => i18n.t('validation.european_date', values),
})

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

Vue.use(vueDebounce)
Vue.use(VueObserveVisibility)
Vue.use(VueLazyload)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
// Vue.component(VueCountdown.name, VueCountdown)

//detect ie11 and add class to body tag to target via css
if (
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style
) {
  document.querySelector('body').classList.add('isIE11')
}

Vue.prototype.$promotions = {
  anyActiveFor(t) {
    const res = store.getters.promotions.filter(f => f.type == t)
    return res.length > 0
  },
  getMinStartFor(t) {
    const res = store.getters.promotions.find(f => f.type == t)
    if (res) {
      return res.from
    }
    return null
  },
  getMaxEndFor(t) {
    const res = store.getters.promotions.find(f => f.type == t)
    if (res) {
      return res.to
    }
    return null
  },
  getOfferCountFor(t) {
    const res = store.getters.promotions.find(f => f.type == t)
    if (res) {
      return res.count
    }
    return 0
  },
}

if (Vue.prototype.$whitelabel.awinId) {
  Vue.use(Awin, {awinId: Vue.prototype.$whitelabel.awinId})
}

if (Vue.prototype.$whitelabel.adcell) {
  Vue.use(Adcell, {adcell: Vue.prototype.$whitelabel.adcell})
}

Vue.prototype.$whitelabel.styleOverride().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    destroyed() {
      dispatcher.destroy()
    },
    created() {
      try {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('r')) {
          const ref = urlParams.get('r')
          const path = () => {
            let e = location,
              t = document.querySelector('link[rel="canonical"][href]')
            if (t) {
              let a = document.createElement('a')
              ;(a.href = t.href),
                a.hostname.replace(/^www\./, '') ===
                  location.hostname.replace(/^www\./, '') && (e = a)
            }
            return e.pathname + e.search || '/'
          }
          var obj = {
            code: ref,
            path: path(),
            referer: document.referer,
            created: new Date(),
          }
          if (urlParams.has('rx')) {
            obj.add = urlParams.get('rx')
          }
          store.dispatch('setReferalToken', obj)
        }
      } catch {
        logger.error('no initial url parameters fetched')
      }
      try {
        dispatcher.setup()
        const gtmSubscribers = createGTMListeners(
          Vue.prototype.$whitelabel.tagManager,
          Vue.gtm,
        )
        const gtagSubscribers = createGTAGListeners(
          Vue.prototype.$whitelabel.analyticsType,
          Vue.$gtag,
        )
        const gaSubscribers = createGAListeners(
          Vue.prototype.$whitelabel.analyticsType,
          Vue.$ga,
        )

        dispatcher.register(gtmSubscribers)
        dispatcher.register(gtagSubscribers)
        dispatcher.register(gaSubscribers)

        if (Vue.prototype.$whitelabel.fbPixelEnabled) {
          const fbpSubscribers = createFBPListeners(
            Vue.prototype.$whitelabel.fbPixelEnabled,
            Vue.analytics.fbq,
          )

          dispatcher.register(fbpSubscribers)
        }

        Vue.prototype.$eventDispatcher = dispatcher
      } catch (err) {
        logger.error('unable to start gtm subscriber', err)
      }
    },
  }).$mount('#app')

  store.dispatch('loadAccesToken')
  store.dispatch('storeInit', {
    site: Vue.prototype.$whitelabel.short.toLowerCase(),
    locale: process.env.VUE_APP_I18N_LOCALE,
  })
})
